import React, { FunctionComponent } from "react"
import roleManagementTableItems from "./RoleManagementTableItems"
import "./RoleManagementTable.css"

const RoleManagementTableHeader: FunctionComponent<{}> = () => {

    return (
        <thead>
            <tr id="b9f61e465fd436180f5dc687b3aa5e2">
                {roleManagementTableItems.map((item, i) =>
                    <th
                        style={{ maxWidth: item.maxWidth }}
                        key={i}
                    >
                        {item.title}
                    </th>
                )}
            </tr>
        </thead>
    )
}

export default RoleManagementTableHeader